
import { defineComponent, onMounted, onBeforeUnmount, ref } from "vue"
// import { Chart } from "highcharts-vue";
// import Highcharts from "highcharts"
import * as echarts from "echarts"
import ecStat from 'echarts-stat'

export default defineComponent({
  setup() {
    let scatterData: (string | number)[][] = []
    let scatterData2: (string | number)[][] = []
    let scatterDataSub: (string | number)[][] = []
    let barData = {}
    let useLog = false
    let markerSize = 2
    let useSelect = false
    // 1
    let visualMin = -1
    let visualMax = 1
    // 1
    let visualMin2 = -1
    let visualMax2 = 1
    // Sub
    let visualMinSub = -1
    let visualMaxSub = 1

    let reverseColor = false
    let selectedMin = 0
    let selectedMax = 50
    let selectedReverse = false
    let polygonData: number[][] = []
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let scatterPlot
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let scatterPlot2
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let scatterPlotSub

    let sExist = ref(true)
    let sInfo = ref('')
    let sCount = ref(0)
    let sMean = ref(0)
    let sMedian = ref(0)
    let sVariance = ref(0)
    let sMax = ref(0)
    let sMin = ref(0)

    /**
     * 获取散点图的配置选项
     */
    const getOption = () => {
      return {
        animation: false,
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {
              type: 'png'
            },
            dataZoom: {
              show: true
            },
            myBrushPolygonSelect: {
              show: true,
              title: 'PolygonSelect, double click to end selection',
              icon: 'path://M0 100 L125 0 L300 0 L330 200 L100 200 Z',
              onclick: () => {
                console.log('PolygonSelect')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('click', (event) => {
                  polygonData.push([event.event.zrX, event.event.zrY])
                  console.log(polygonData)
                  if (polygonData.length > 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    scatterPlot?.dispatchAction({
                      type: 'brush',
                      areas: [
                        {
                          // 指定选框的类型。可以为 'polygon', 'rect', 'lineX', 'lineY'
                          brushType: 'polygon',
                          // 如果是“全局选框”，则使用 range 来描述选框的范围（里面是像素坐标）。
                          range: polygonData.slice(1)
                        }
                      ]
                    })
                  }
                })
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot?.getZr()?.on('dblclick', (event) => {
                  console.log('dblclick')
                  polygonData = []
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('click')
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot?.getZr()?.off('dblclick')
                })
              }
            }
          }
        },
        visualMap: useSelect ? {
          seriesIndex: 2,
          show: false
        } : {
          type: 'continuous',
          min: visualMin,
          max: visualMax,
          dimension: 2, // series.data 的第三个维度（即 value[2]）被映射
          seriesIndex: 0, // 对第一个系列进行映射。
          inRange: {
            // 选中范围中的视觉配置
            color: reverseColor ? ['red', '#121122', 'blue'] : ['blue', '#121122', 'red'], // 定义了图形颜色映射的颜色列表，
          },
          top: '1%',
        },
        dataset: [
          {
            dimensions: ['x', 'y', 'value'],
            source: useLog ? retrieveLogData(scatterData) : scatterData
          }
        ],
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Gene 1',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x: ' + Number(data[0]).toFixed(2) + ' <br> y: '
                + Number(data[1]).toFixed(2) + '<br> value: '
                + Number(data[2]).toFixed(2)
          }
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
        },
        brush: {
          inBrush: {
            opacity: 1
          },
          throttleType: 'debounce',
          throttleDelay: 1000,
        },
        series: {
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: useLog ? retrieveLogData(scatterData) : scatterData,
          symbolSize: markerSize,
          itemStyle: useSelect ? {
            color: (params: any) => {
              if (params.data[2] >= selectedMin && params.data[2] <= selectedMax) {
                return selectedReverse ? 'rgb(255,0,0)' : 'rgb(128,128,128)'
              } else {
                return selectedReverse ? 'rgb(128,128,128)' : 'rgb(255,0,0)'
              }
            },
          } : {},
        },

      }
    }


    const getOption2 = () => {
      return {
        animation: false,
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {
              type: 'png'
            },
            dataZoom: {
              show: true
            },
            myBrushPolygonSelect: {
              show: true,
              title: 'PolygonSelect, double click to end selection',
              icon: 'path://M0 100 L125 0 L300 0 L330 200 L100 200 Z',
              onclick: () => {
                console.log('PolygonSelect')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot2?.getZr()?.on('click', (event) => {
                  polygonData.push([event.event.zrX, event.event.zrY])
                  console.log(polygonData)
                  if (polygonData.length > 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    scatterPlot2?.dispatchAction({
                      type: 'brush',
                      areas: [
                        {
                          // 指定选框的类型。可以为 'polygon', 'rect', 'lineX', 'lineY'
                          brushType: 'polygon',
                          // 如果是“全局选框”，则使用 range 来描述选框的范围（里面是像素坐标）。
                          range: polygonData.slice(1)
                        }
                      ]
                    })
                  }
                })
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlot2?.getZr()?.on('dblclick', (event) => {
                  console.log('dblclick')
                  polygonData = []
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot2?.getZr()?.off('click')
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlot2?.getZr()?.off('dblclick')
                })
              }
            }
          }
        },
        visualMap: useSelect ? {
          seriesIndex: 2,
          show: false
        } : {
          type: 'continuous',
          min: visualMin2,
          max: visualMax2,
          dimension: 2, // series.data 的第三个维度（即 value[2]）被映射
          seriesIndex: 0, // 对第一个系列进行映射。
          inRange: {
            // 选中范围中的视觉配置
            color: reverseColor ? ['red', '#121122', 'blue'] : ['blue', '#121122', 'red'], // 定义了图形颜色映射的颜色列表，
          },
          top: '1%',
        },
        dataset: [
          {
            dimensions: ['x', 'y', 'value'],
            source: useLog ? retrieveLogData(scatterData2) : scatterData2
          }
        ],
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Gene 2',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x: ' + Number(data[0]).toFixed(2) + ' <br> y: '
                + Number(data[1]).toFixed(2) + '<br> value: '
                + Number(data[2]).toFixed(2)
          }
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
        },
        brush: {
          inBrush: {
            opacity: 1
          },
          throttleType: 'debounce',
          throttleDelay: 1000,
        },
        series: {
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: useLog ? retrieveLogData(scatterData2) : scatterData2,
          symbolSize: markerSize,
          itemStyle: useSelect ? {
            color: (params: any) => {
              if (params.data[2] >= selectedMin && params.data[2] <= selectedMax) {
                return selectedReverse ? 'rgb(255,0,0)' : 'rgb(128,128,128)'
              } else {
                return selectedReverse ? 'rgb(128,128,128)' : 'rgb(255,0,0)'
              }
            },
          } : {},
        },

      }
    }



    const getOptionSub = () => {
      return {
        animation: false,
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {
              type: 'png'
            },
            dataZoom: {
              show: true
            },
            myBrushPolygonSelect: {
              show: true,
              title: 'PolygonSelect, double click to end selection',
              icon: 'path://M0 100 L125 0 L300 0 L330 200 L100 200 Z',
              onclick: () => {
                console.log('PolygonSelect')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlotSub?.getZr()?.on('click', (event) => {
                  polygonData.push([event.event.zrX, event.event.zrY])
                  console.log(polygonData)
                  if (polygonData.length > 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    scatterPlotSub?.dispatchAction({
                      type: 'brush',
                      areas: [
                        {
                          // 指定选框的类型。可以为 'polygon', 'rect', 'lineX', 'lineY'
                          brushType: 'polygon',
                          // 如果是“全局选框”，则使用 range 来描述选框的范围（里面是像素坐标）。
                          range: polygonData.slice(1)
                        }
                      ]
                    })
                  }
                })
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                scatterPlotSub?.getZr()?.on('dblclick', (event) => {
                  console.log('dblclick')
                  polygonData = []
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlotSub?.getZr()?.off('click')
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  scatterPlotSub?.getZr()?.off('dblclick')
                })
              }
            }
          }
        },
        visualMap: useSelect ? {
          seriesIndex: 2,
          show: false
        } : {
          type: 'continuous',
          min: visualMinSub,
          max: visualMaxSub,
          dimension: 2, // series.data 的第三个维度（即 value[2]）被映射
          seriesIndex: 0, // 对第一个系列进行映射。
          inRange: {
            // 选中范围中的视觉配置
            color: reverseColor ? ['red', '#121122', 'blue'] : ['blue', '#121122', 'red'], // 定义了图形颜色映射的颜色列表，
          },
          top: '1%',
        },
        dataset: [
          {
            dimensions: ['x', 'y', 'value'],
            source: useLog ? retrieveLogData(scatterDataSub) : scatterDataSub
          }
        ],
        grid: {
          top: '5%',
          left: 'center',
          width: 'auto',
          height: '80%'
        },
        title: {
          text: 'Gene 1 - Gene 2',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          },
          formatter: (params: any) => {
            const data = params.data
            return 'x: ' + Number(data[0]).toFixed(2) + ' <br> y: '
                + Number(data[1]).toFixed(2) + '<br> value: '
                + Number(data[2]).toFixed(2)
          }
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
        },
        brush: {
          inBrush: {
            opacity: 1
          },
          throttleType: 'debounce',
          throttleDelay: 1000,
        },
        series: {
          type: 'scatter',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: useLog ? retrieveLogData(scatterDataSub) : scatterDataSub,
          symbolSize: markerSize,
          itemStyle: useSelect ? {
            color: (params: any) => {
              if (params.data[2] >= selectedMin && params.data[2] <= selectedMax) {
                return selectedReverse ? 'rgb(255,0,0)' : 'rgb(128,128,128)'
              } else {
                return selectedReverse ? 'rgb(128,128,128)' : 'rgb(255,0,0)'
              }
            },
          } : {},
        },

      }
    }
    /**
     * 获取基因强度经log的数据
     * @param data 基因数据
     */
    const retrieveLogData = (data: (string | number)[][]) => {
      let result = []
      result.push(data[0])
      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === 'x') {
          continue
        }
        result.push([data[i][0], data[i][1], Math.log(Number(data[i][2]) + 1)])
      }
      return result
    }

    /**
     * 设置散点图以及直方图的数据
     * @param data 基因数据
     */
    const setPlotData = (data: (string | number)[][]) => {
      scatterData = data
      updatePlot()
    }

    const setPlotData2 = (data: (string | number)[][]) => {
      scatterData2 = data
      updatePlot()
    }

    const setPlotDataSub = (data: (string | number)[][]) => {
      scatterDataSub = data
      updatePlot()
    }

    /**
     * 更改散点图的点大小
     * @param size
     */
    const changeMarkerSize = (size: number) => {
      markerSize = size
      console.log('marker size: ', markerSize)
      updatePlot()
    }

    /**
     * 设置散点图color是否反转
     * @param flag
     */
    const setReverseColor = (flag: boolean) => {
      reverseColor = flag
      updatePlot()
    }

    /**
     * 设置散点图最值颜色对应的基因强度的最小值和最大值
     * @param vMin 最小值
     * @param vMax 最大值
     */
    const setVisualMinMax = (vMin: number, vMax: number) => {
      visualMin = vMin
      visualMax = vMax
      useSelect = false
      updatePlot()
    }
    const setVisualMinMax2 = (vMin: number, vMax: number) => {
      visualMin2 = vMin
      visualMax2 = vMax
      useSelect = false
      updatePlot()
    }
    const setVisualMinMaxSub = (vMin: number, vMax: number) => {
      visualMinSub = vMin
      visualMaxSub = vMax
      useSelect = false
      updatePlot()
    }

    /**
     * 设置基因强度是否log
     * @param flag
     */
    const setLog = (flag: boolean) => {
      useLog = flag
      updatePlot()
    }

    /**
     * 设置基因强度的选择区间
     * @param vMin 设置的基因强度的区间最小值
     * @param vMax 设置的基因强度的区间最大值
     */
    const setSelectMinMax = (vMin: number, vMax: number) => {
      selectedMin = vMin
      selectedMax = vMax
      useSelect = true
      console.log('select min max: ', selectedMin, selectedMax)
      updatePlot()
    }

    /**
     * 设置基因强度的选择区间是否反转
     * @param flag
     */
    const setSelectReverse = (flag: boolean) => {
      selectedReverse = flag
      updatePlot()
    }

    /**
     * 更新散点图
     */
    const updatePlot = () => {
      console.log('start update')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.setOption(getOption(), true)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot2?.setOption(getOption2(), true)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlotSub?.setOption(getOptionSub(), true)
    }


    /**
     * 当窗口变化时用来调整图的大小
     */
    const resizePlot = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot?.resize()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot2?.resize()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlotSub?.resize()
    }

    onMounted(() => {
      console.log('express onMounted')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot = echarts.init(document.getElementById('geneComparePlot1'))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot2 = echarts.init(document.getElementById('geneComparePlot2'))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlotSub = echarts.init(document.getElementById('geneComparePlotSub'))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.addEventListener('resize', resizePlot)
    })

    onBeforeUnmount(() => {
      console.log('express onBeforeUnmount')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.removeEventListener('resize', resizePlot)

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot.dispose()
     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlot2.dispose()
     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      scatterPlotSub.dispose()
    })

    return {
      sExist,
      sInfo,
      sCount,
      sMean,
      sMedian,
      sVariance,
      sMax,
      sMin,
      setPlotData,
      setPlotData2,
      setPlotDataSub,
      changeMarkerSize,
      setReverseColor,
      setVisualMinMax,
      setVisualMinMax2,
      setVisualMinMaxSub,
      setSelectMinMax,
      setSelectReverse,
      setLog
    }
  }
})

